export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/browser-server.fa9d8cca.worker.js");
}
